import script from "./InLogUbica.vue?vue&type=script&lang=ts&setup=true"
export * from "./InLogUbica.vue?vue&type=script&lang=ts&setup=true"

import "./InLogUbica.vue?vue&type=style&index=0&id=15f75438&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15f75438"]])

export default __exports__